import { Helmet } from "react-helmet-async";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import CTASection from "@/components/landing/CTASection";
import SeoTags from "@/components/seo/SeoTags";

const Index = () => {
  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SnippSnapp",
    url: "https://snippsnapp.se",
    logo: "https://snippsnapp.se/snippsnapp-logo.png",
  };

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "SnippSnapp",
    url: "https://snippsnapp.se",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://snippsnapp.se/faq?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <div className="min-h-screen bg-gradient-brand">
      <SeoTags
        path="/"
        title="SnippSnapp – Skapa din egen magiska saga"
        description="Skapa personliga, AI-genererade sagoböcker där ditt barn är hjälten. Välj utseende, intressen och stil – få en unik saga på minuter."
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      </Helmet>
      {/* Unified background gradient */}
      <div className="fixed inset-0 z-0 bg-gradient-to-b from-teal/5 via-background to-background pointer-events-none" />

      <Navbar />
      <main className="relative z-10">
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
